import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import ScrollToTop from '@/components/feature/ScrollToTop';
import HeroSection from './components/HeroSection';
import CategorySection from './components/CategorySection';
import TrendingSection from './components/TrendingSection';
import LatestSection from './components/LatestSection';
import RankingSection from './components/RankingSection';
import ArticleSection from './components/ArticleSection';

export default function Home() {
  return (
    <>
      <ScrollToTop />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'WebPage',
            name: '91动漫 - 正版高清动漫在线观看平台',
            description:
              '91动漫是深受动漫迷喜爱的在线观看平台，汇聚海量正版高清动漫资源，涵盖热血、恋爱、奇幻、搞笑等多种类型。每日更新最新番剧。',
            url: 'https://www.91anime.com/',
            isPartOf: {
              '@type': 'WebSite',
              name: '91动漫',
              url: 'https://www.91anime.com/',
            },
          }),
        }}
      />
      <div className="min-h-screen bg-background-50">
        <Navbar />
        <main>
          <HeroSection />
          <CategorySection />
          <TrendingSection />
          <LatestSection />
          <RankingSection />
          <ArticleSection />
        </main>
        <Footer />
      </div>
    </>
  );
}